
import { Component, Vue, Watch } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';

import TextField from '../../../framework/fields/TextField.vue';
import DateField from '../../../framework/fields/DateField.vue';
import NumberField from '../../../framework/fields/NumberField.vue';
import { sharedState } from '../../../framework/state';

import { errorToast, successToast } from '../../service/toast_service';
import { findVehicleContractWithRegistrationNumber } from '../../client/vehicle_contract_client';
import { ApplicationResource } from '../../../../common/application/enumeration/ApplicationResource';

@Component({
    components: {
        TextField,
        ValidationObserver,
        NumberField,
        DateField,
    },
})
export default class RegistrationNumberLogin extends Vue {
    // Constants
    readonly resourceType = ApplicationResource.VEHICLE;

    // State
    shared = sharedState;
    local = {
        vehicleRegistrationNumber: '',
        loading: false,
    };

    // Functions
    async mounted() {}

    async goToDashboard() {
        this.local.loading = true;

        const response = await findVehicleContractWithRegistrationNumber(this.local.vehicleRegistrationNumber);

        if (response.id) {
            successToast(this, 'message.vehicleContractFound');

            this.$router.push(`/vehicle/${this.local.vehicleRegistrationNumber.toLowerCase()}`);
        } else {
            errorToast(this, 'message.noVehicleContractFound');
        }

        this.local.loading = false;
    }

    @Watch('local.vehicleRegistrationNumber')
    onRegistrationNumberChange(newValue: string) {
        this.local.vehicleRegistrationNumber = this.local.vehicleRegistrationNumber.toUpperCase();

        if (newValue.length === 3) {
            this.local.vehicleRegistrationNumber += '-';
        }
    }
}
